/**
 * Параметры выбранной модели
 */
import {SelectedItemModel} from "./selectedItem.model";

export interface SelectedModelParamModel {
  isSelectedAll: boolean; // Признак выбрано все
  selectedModel: Array<SelectedItemModel>; // Список выбранных элементов
}
